import React from 'react';
import Layout from '../components/Layout';
import UserManagement from '../components/UserManagement';

const Admin = () => {
  return (
    <Layout>
      <div className="px-4 py-6 sm:px-0">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Admin Panel</h1>
        <UserManagement />
      </div>
    </Layout>
  );
};

export default Admin;


